import {PageTransformFn} from '@/src/core/domain/page/functions/types'
import {ServerPageData} from '@/src/core/domain/entities/page/page-data'
import {PageType} from '@/src/core/domain/entities/page'
import React from 'react'
import {ShoeTestingContent} from '@/src/(pages)/testing/suspense/shoe-content'
import {ShoeTestingPageContent} from '@/src/(pages)/testing/ui/shoe-testing-screen'
import {parseHTMLContent} from '@/src/shared/modules/html-snippets/parse'

export const shoeTestingTransform: PageTransformFn<ShoeTestingPageContent> = async function (
  data: ServerPageData<ShoeTestingPageContent>,
  session,
  isMobile,
) {
  if (isMobile && data.type === PageType.ShoeTesting) {
    // @ts-ignore TODO: исправить
    data.bottomContent = data?.content?.bottom_block && (
      <ShoeTestingContent promise={parseHTMLContent(data.content.bottom_block)} />
    )
  }
  return data
}
